import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [trialExpired, setTrialExpired] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/', { replace: true });
    } catch (err) {
      if (err.message === 'TRIAL_EXPIRED') {
        setTrialExpired(true);
      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0E27] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Logo / Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
            Scheme<span className="text-[#00D4FF]">Sync</span>
          </h1>
          <p className="text-[#00E676] font-semibold mt-1 text-lg">Real Estate</p>
          <p className="text-gray-400 mt-2">AI-Powered Property Evaluation Platform</p>
          <p className="text-gray-500 text-sm mt-1">Powered by AiDA Advisory</p>
        </div>

        {/* Login Card */}
        <div className="bg-[#1A2744] rounded-xl shadow-2xl p-6 md:p-8 border border-[#546E7A]/30">
          <h2 className="text-xl font-semibold text-white mb-6">Sign In</h2>

          {trialExpired && (
            <div className="bg-yellow-900/50 border border-yellow-600 text-yellow-200 px-4 py-4 rounded-lg mb-4">
              <p className="font-semibold text-base mb-2">Your 7-day trial has ended</p>
              <p className="text-sm mb-3 text-yellow-300/80">Your trial data is still saved. Subscribe to pick up where you left off.</p>
              <a href="https://aida-advisory.com/pricing.html" className="inline-block bg-yellow-600 hover:bg-yellow-500 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors">
                Subscribe Now →
              </a>
            </div>
          )}

          {error && (
            <div className="bg-red-900/50 border border-red-700 text-red-300 px-4 py-3 rounded-lg mb-4 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 bg-[#0A0E27] border border-[#546E7A]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent"
                placeholder="agent@brokerage.com"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 bg-[#0A0E27] border border-[#546E7A]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent"
                placeholder="Enter your password"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 px-4 bg-[#00D4FF] hover:bg-[#00B8D4] disabled:bg-[#00D4FF]/50 disabled:cursor-not-allowed text-[#0A0E27] font-semibold rounded-lg transition-colors duration-200"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <a href="/trial-login" className="text-[#00D4FF] hover:text-[#00E676] text-sm font-medium transition-colors">
              Start a free 7-day trial →
            </a>
          </div>
        </div>

        <p className="text-center text-gray-600 text-xs mt-6">
          &copy; 2026 AiDA Advisory LLC. All rights reserved.
        </p>
      </div>
    </div>
  );
}
